const ENTITY_NAMES =
  'job|contact|candidate|application|interview|offer|requisition|department|office|project|user|template|flow|report';
const ENTITY = `(${ENTITY_NAMES})`;
const FIELD_ENTITY = `(${ENTITY_NAMES}|task|stage)`;

const UI_BLOCK_RE = /<!--ui:[\s\S]*?-->/gi;
const CTX_MARKER_RE = /<ctx:[^>]*>/gi;
const MENTION_RE = new RegExp(`@${ENTITY}:\\d+`, 'gi');
const FIELD_ID_RE = new RegExp(
  `\\b${FIELD_ENTITY}[ _-]?id\\s*[:=#-]?\\s*\\d+\\b`,
  'gi'
);
const PARENTHESIZED_FIELD_ID_RE = new RegExp(
  `\\s*\\(\\s*${FIELD_ENTITY}[ _-]?id\\s*[:=#-]?\\s*\\d+\\s*\\)`,
  'gi'
);
const ENTITY_ID_RE = new RegExp(`\\b${ENTITY}\\s+#?\\d+\\b`, 'gi');
const GENERIC_ID_RE = /\bID\s*[:=#-]\s*\d+\b/gi;
const SENTENCE_RECORD_RE = /([.!?]\s+)the record\b/g;

const replaceEntityRef = (_match: string, entity: string) =>
  `the ${entity.toLowerCase()}`;

/**
 * Display-time defense for historical assistant messages. New responses are
 * sanitized by AgentForge before streaming/persistence; this keeps messages
 * saved before that guard from exposing internal record identifiers.
 * Ordinary counts, dates, and other standalone numbers are preserved.
 */
export const sanitizeAssistantProse = (content: string): string =>
  content
    .replace(UI_BLOCK_RE, '')
    .replace(CTX_MARKER_RE, '')
    .replace(PARENTHESIZED_FIELD_ID_RE, '')
    .replace(MENTION_RE, replaceEntityRef)
    .replace(FIELD_ID_RE, replaceEntityRef)
    .replace(ENTITY_ID_RE, replaceEntityRef)
    .replace(GENERIC_ID_RE, 'the record')
    .replace(SENTENCE_RECORD_RE, '$1The record');
